import { adminDownloadLogProductExcel } from "helpers/backend_helpers";
import moment from "moment";
import { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { toast } from "react-toastify";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const DownloadModalLogProduct = ({ show, onCloseClick }: any) => {
  const [filterDate, setFilterDate] = useState<any>([]);
  const [filterStatus, setFilterStatus] = useState<any>(null);
  const [filterName, setFilterName] = useState<string>("");
  const [filterSender, setFilterSender] = useState<string>("");
  const [flatpickrKey, setFlatpickrKey] = useState(0);
  const [downloadType, setDownloadType] = useState<string>("all");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const status = [
    { value: "MASUK", label: "MASUK" },
    { value: "KELUAR", label: "KELUAR" },
  ];

  const handleDownloadTypeChange = (type: string) => {
    setDownloadType(type);
    if (type === "all") {
      setFilterDate([]);
      setFilterStatus(null);
      setFilterName("");
      setFilterSender("");
      setFlatpickrKey((prev) => prev + 1);
    }
  };

  const downloadData = async () => {
    if (downloadType === "specific") {
      const hasDateFilter = filterDate[0] && filterDate[1];
      const hasNameFilter = filterName.trim() !== "";
      const hasSenderFilter = filterSender.trim() !== "";
      const hasStatusFilter = filterStatus !== null;

      if (
        !hasDateFilter &&
        !hasNameFilter &&
        !hasSenderFilter &&
        !hasStatusFilter
      ) {
        toast.error("Pilih minimal satu filter untuk download data tertentu!");
        return;
      }
    }

    setIsLoading(true);
    try {
      let query: any = {};

      if (downloadType === "specific") {
        if (filterDate[0] && filterDate[1]) {
          query.startDate = moment(filterDate[0]).format("YYYY-MM-DDTHH:mm:ss");
          query.endDate = moment(filterDate[1]).format("YYYY-MM-DDTHH:mm:ss");
        }
        if (filterName.trim()) {
          query.name = filterName.trim();
        }
        if (filterSender.trim()) {
          query.sender = filterSender.trim();
        }
        if (filterStatus) {
          query.type = filterStatus.value;
        }
      }

      const response: any = await adminDownloadLogProductExcel(query);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Buku Catatan Barang.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Unduh data buku catatan barang berhasil");
      onCloseClick();
    } catch (error) {
      toast.error("Gagal mengunduh data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!show) {
      setFilterDate([]);
      setFilterStatus(null);
      setFilterName("");
      setFilterSender("");
      setDownloadType("all");
      setFlatpickrKey((prev) => prev + 1);
      setIsLoading(false);
    }
  }, [show]);

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="md"
    >
      <ModalHeader
        className="bg-gradient-to-r from-blue-50 to-indigo-50 border-0 p-4"
        toggle={onCloseClick}
      >
        <div className="d-flex align-items-center">
          <div>
            <h5 className="mb-0 text-dark fw-semibold">
              Unduh Data Buku Catatan Barang
            </h5>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        <div className="mb-4">
          <Label className="form-label text-dark fw-semibold mb-3">
            Pilih Tipe Unduhan
          </Label>
          <div className="d-flex gap-3">
            <div
              className={`flex-fill border rounded-3 p-3 cursor-pointer transition-all ${
                downloadType === "all"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25 hover:border-primary"
              }`}
              onClick={() => handleDownloadTypeChange("all")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadAll"
                  checked={downloadType === "all"}
                  onChange={() => handleDownloadTypeChange("all")}
                />
                <Label
                  className="form-check-label d-flex align-items-center cursor-pointer"
                  htmlFor="downloadAll"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-folder-download-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Semua Data</div>
                    <small className="text-muted">
                      Download semua data barang
                    </small>
                  </div>
                </Label>
              </div>
            </div>

            <div
              className={`flex-fill border rounded-3 p-3 cursor-pointer transition-all ${
                downloadType === "specific"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25 hover:border-primary"
              }`}
              onClick={() => handleDownloadTypeChange("specific")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadSpecific"
                  checked={downloadType === "specific"}
                  onChange={() => handleDownloadTypeChange("specific")}
                />
                <Label
                  className="form-check-label d-flex align-items-center cursor-pointer"
                  htmlFor="downloadSpecific"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-filter-3-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Data Tertentu</div>
                    <small className="text-muted">Filter data barang</small>
                  </div>
                </Label>
              </div>
            </div>
          </div>
        </div>

        {downloadType === "specific" && (
          <div className="animate-fade-in">
            <div className="border-top pt-4 mt-2">
              <Label className="form-label text-dark fw-semibold mb-3">
                <i className="ri-filter-line me-2"></i>
                Filter Data
              </Label>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-calendar-line me-1"></i>
                  Rentang Tanggal & Waktu
                </Label>
                <Flatpickr
                  key={flatpickrKey}
                  className="form-control shadow-sm"
                  options={{
                    mode: "range",
                    dateFormat: "Y-m-d H:i",
                    enableTime: true,
                    time_24hr: true,
                  }}
                  onChange={(e) => setFilterDate(e)}
                  value={filterDate}
                  placeholder="Pilih rentang tanggal & waktu"
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-box-3-line me-1"></i>
                  Nama Barang
                </Label>
                <Input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Cari nama barang..."
                  value={filterName}
                  onChange={(e) => setFilterName(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-user-line me-1"></i>
                  Pengirim
                </Label>
                <Input
                  type="text"
                  className="form-control shadow-sm"
                  placeholder="Cari nama pengirim..."
                  value={filterSender}
                  onChange={(e) => setFilterSender(e.target.value)}
                />
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-exchange-line me-1"></i>
                  Status
                </Label>
                <Select
                  value={filterStatus}
                  onChange={(e: any) => setFilterStatus(e)}
                  options={status}
                  className="basic-multi-select shadow-sm"
                  classNamePrefix="select"
                  placeholder="Pilih Status"
                  isClearable
                />
              </div>
            </div>
          </div>
        )}
      </ModalBody>

      <ModalFooter className="bg-light border-0 p-4">
        <button
          type="button"
          className="btn btn-light border shadow-sm px-4 btn-sm"
          onClick={onCloseClick}
          disabled={isLoading}
        >
          <i className="ri-close-line me-1"></i>
          Batal
        </button>
        <button
          type="button"
          className="btn btn-primary shadow-sm px-4 btn-sm"
          onClick={downloadData}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Mengunduh...
            </>
          ) : (
            <>
              <i className="ri-download-2-line me-1"></i>
              Unduh Data
            </>
          )}
        </button>
      </ModalFooter>

      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .hover\\:border-primary:hover {
          border-color: #6366f1 !important;
        }

        .transition-all {
          transition: all 0.2s ease-in-out;
        }

        .cursor-pointer {
          cursor: pointer;
        }

        .bg-opacity-10 {
          --bs-bg-opacity: 0.1;
        }

        .border-opacity-25 {
          --bs-border-opacity: 0.25;
        }
      `}</style>
    </Modal>
  );
};

export default DownloadModalLogProduct;
